import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { UserAccountType } from 'entities/User';
import { ArrivalsStatisticsFilterKeys } from '../../model/types';

interface AccountTypeSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const AccountTypeSelect: FC<AccountTypeSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'user', 'common']);

  const accountTypeOptions = useMemo<Array<{ label: string; value: UserAccountType }>>(() => {
    return [
      { label: t('Personal', { ns: 'user' }), value: UserAccountType.PERSONAL },
      { label: t('Business', { ns: 'user' }), value: UserAccountType.BUSINESS },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(ArrivalsStatisticsFilterKeys.accountType);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Account type', { ns: 'user' })}
      placeholder={t('All')}
      bordered
      allowClear
      options={accountTypeOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
